export const LLM_PROVIDER_ENUM_VALUES = ['openai', 'azure_openai', 'inception', 'anthropic', 'google'];
export const VIEW_TYPE_LABELS = {
    single_prompt: 'Single Prompt',
    template: 'Template',
    double_state: 'Double-state',
};
